import "./moduleConfig.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { useSelector } from "react-redux";
import { panelInformation } from "../../DataFiles/panelInformation";

const ModuleConfig = (props) => {
  const { tableContent, roofDetail, index } = props;
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const check = quantityInfo.allRoof;
  const projectImages = useSelector((state) => state.img.structureImage);

  const selectionType = roofDetail.structureType;

  let imageSrc = projectImages;
  if (!imageSrc) {
    imageSrc = roofInfo.structureImageUrl;
  }
  const panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  const panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  const list = roofDetail.multipleStructure;
  let pvModule;
  let tiltAngle = 15;

  if (selectionType === "Single") {
    pvModule = roofDetail.pvModule;
  } else {
    pvModule = Object.values(list).reduce(
      (sum, value) => sum + value.pvModule,
      0
    );
  }

  const totalSquareMeter = pvModule * panel.height * panel.width;

  if (roofDetail.roofType === "Shed Roof") {
    tiltAngle = roofDetail.buildingPitch;
  } else if (
    roofDetail.roofType === "Customized Roof" ||
    roofDetail.roofType === "Carport"
  ) {
    tiltAngle = 10;
  }

  let moduleConfiguration = [
    {
      title: "Name",
      value: roofDetail.structureFacing,
    },
    {
      title: "PV manufacturer",
      value: roofDetail.module,
    },
    {
      title: "PV module type",
      value: roofDetail.moduleType,
    },

    {
      title: "Tilt",
      value: `${tiltAngle} degrees`,
    },
    {
      title: "Azimuth",
      value: roofDetail.azimuth,
    },
    {
      title: "Installation roof type",
      value: roofDetail.roofType,
    },
    {
      title: "PV covered area",
      value: `${Number(totalSquareMeter.toFixed(1)).toLocaleString(
        "en-US"
      )} meter square`,
    },
  ];

  function tableRender(tableData) {
    return (
      <div className="render-function">
        <table className="render-table">
          <thead>
            <tr>
              <td>Property</td>
              <td>Value</td>
            </tr>
          </thead>
          <tbody>
            {tableData.map((item, index) => {
              return (
                <tr key={index} className={index % 2 === 0 ? "one" : "two"}>
                  <td className="left">{item.title}</td>
                  <td className="right">{item.value}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
  const pageDetail = tableContent.find(
    (item) => item.title === "PV Configuration"
  );

  const title = check
    ? quantityInfo.electricalConfiguration === "All Roof"
      ? `PV Module Configuration (Roof ${index + 1})`
      : `PV Module Configuration (Roof ${index + 1})`
    : `PV Module Configuration`;

  return (
    <div id="module-config" className="module-config">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="mc-body">
        <p> {title} </p>
        <div className="data-tables">
          {/* PV Panel */}
          {tableRender(moduleConfiguration)}
        </div>
        <p className="map-title">Map Layout</p>
        <img className="img" src={imageSrc} alt="e-configurator-design"></img>
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageDetail ? pageDetail.pageNo : 12}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default ModuleConfig;
